import React, { useEffect } from 'react';
import classnames from 'classnames/bind';
import { Button } from '../../components/Button';
import { Loader } from '../../components/Loader';
import { Badge } from '../../components/Badge';
import { NoData } from '../../components/NoData';
import { FeaturesList } from '../../components/FeaturesList';
import { useDocumentTitle } from '../../shared/use-document-title';
import { useOrders } from '../../shared/use-orders';
import styles from './AccountPurchasesPage.css';

const cx = classnames.bind(styles);

function AccountPurchasesPage() {
    const { orders, isLoading } = useOrders();

    useEffect(() => {
        if (window.location.hash && !isLoading) {
            document.querySelector(window.location.hash)?.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
    }, [isLoading]);

    useDocumentTitle('My Purchases');

    const getProductProps = () => ({});

    const renderContent = () => {
        if (isLoading) {
            return (
                <div className={styles.loaderWrapper}>
                    <Loader variant='secondary' />
                </div>
            );
        }

        if (orders.length === 0) {
            return (
                <NoData title='No purchases yet'>
                    <p>You do not have any purchases yet. They will appear here once you make one.</p>
                </NoData>
            );
        }

        return (
            <ul className={styles.orders}>
                {orders.map(orderData => {
                    const { imageUrl, featureType } = getProductProps(orderData.productId);

                    if (!imageUrl) return null;

                    return (
                        <li
                            key={orderData.id}
                            className={styles.orderCard}
                            id={`order-${orderData.id}`}
                        >
                            <div className={styles.orderCardHeader}>
                                <img
                                    src={imageUrl}
                                    alt='guide'
                                />
                                <Badge
                                    variant='success'
                                    label='Already purchased'
                                    iconName='shoppingOrder'
                                />
                            </div>
                            <div className={styles.blockWithBorder}>
                                <h2 className={styles.orderCardTitle}>{orderData.name}</h2>
                            </div>
                            <ul className={cx('orderCardInfoItems', 'blockWithBorder')}>
                                <li className={styles.orderCardInfoItem}>
                                    <span>Price</span>
                                    <span>{orderData.price}</span>
                                </li>
                                <li className={styles.orderCardInfoItem}>
                                    <span>Purchase date</span>
                                    <span>{orderData.purchaseDate}</span>
                                </li>
                            </ul>
                            <FeaturesList type={featureType} />
                            <Button
                                label='Download pdf'
                                type='secondary'
                                link={{ to: orderData.downloadLink, target: '_blank' }}
                                className={styles.button}
                            />
                        </li>
                    );
                })}
            </ul>
        );
    };

    return renderContent();
}

export {
    AccountPurchasesPage
};
